module.exports = __webpack_public_path__ + "img/white.af1eb54.svg";